export const TAGS = [
  'AI',
  'REACT',
  // 'FULLSTACK',
  'MOBILE',
  'CHROME EXTENSION',
  'KAGGLE',
  'GAME DEVELOPMENT',
] as const;

export type Tag = (typeof TAGS)[number];
export type Tags = Array<Tag>;
